import {Axios} from '../axios/axios.js'
//获取规则列表
export const getRulesList = (e) => {
  return Axios({
    url:"/rule/get_rule_list",
    method:'put',
    data:e
  })
}
//获取区域列表
export const getZoneList = (e) => {
  return Axios({
    url:"/rule/get_zone_list",
    method:'put',
    data:e
  })
}
//删除规则
export const deleteRuleData = (e) => {
  return Axios({
    url:"/rule/del_rule",
    method:'put',
    data:e
  })
}
//清除区域
export const clearZone = (e) => {
  return Axios({
    url:"/rule/clear_zone",
    method:'put',
    data:e
  })
}
//编辑区域
export const editZone = (e) => {
  return Axios({
    url:"/rule/edit_zone",
    method:'put',
    data:e
  })
}
//变更状态
export const changeStatus = (e) => {
  return Axios({
    url:"/rule/change_rule_status",
    method:'put',
    data:e
  })
}
//新增规则
export const addNewRules = (e) => {
  return Axios({
    url:"/rule/add_rule",
    method:'put',
    data:e
  })
}
//编辑接口
export const eidtNewRules = (e) => {
  return Axios({
    url:"/rule/edit_rule",
    method:'put',
    data:e
  })
}
//导入接口
export const exporeCode = (e) => {
  return Axios({
    url:"rule/expore_postcode",
    method:'post',
    data:e
  })
}
